// country-selector

class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    }
    // this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))
    this.addEventListener('click', this.toggleSelector.bind(this))
    let _this = this
    document.addEventListener('keyup', this.onContainerKeyUp.bind(this))
    document.addEventListener('click', function (e) {
      if (e.target.closest('localization-form') == null) {
        _this.hidePanel()
      }
    })

    const returnTo = this.querySelector('input[name="return_to"]')
    if (returnTo) {
      returnTo.value = window.location.pathname
    }

    this.addEventListener('click', (event) => {
      const linkElement = event.target.tagName === 'A' ? event.target : event.target.closest('a')
      if (linkElement !== null) {
        document
          .querySelector('banner-country-selector')
          ?.setLocalStorage(linkElement.dataset.value)
      }
    })
  }

  async scrollToSelectedCountry() {
    if (this.classList.contains('language-selector')) {
      return
    }
    const selectedCountry = await this.checkForElement('.disclosure__item a[aria-current="true"]')
    if (selectedCountry) {
      const countryCode = selectedCountry.dataset.value
      const firstCountry = this.querySelector(`.disclosure__item a[data-value="${countryCode}"]`)
      if (this.querySelector('.js-country-list') !== null && firstCountry !== null) {
        this.querySelector('.js-country-list').scrollTop = firstCountry.offsetTop
      }
    }
  }

  hidePanel() {
    const button = this.elements.button
    const panel = this.elements.panel
    if (button) button.setAttribute('aria-expanded', 'false')
    if (panel) panel.setAttribute('hidden', true)
  }

  onContainerKeyUp(event) {
    if (event.key === 'Escape' && this.elements.button.getAttribute('aria-expanded') === 'true') {
      this.hidePanel()
      this.elements.button.focus()
    }
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.elements.input.value = event.currentTarget.dataset.value
    let countryCodeStored = event.currentTarget.dataset.value
    countryCodeStored = countryCodeStored.toLowerCase()
    localStorage.setItem('country_code', countryCodeStored)
    if (form) form.submit()
  }

  toggleSelector() {
    const isPanelHidden = this.elements.panel.getAttribute('hidden')
    const isButtonExpanded = this.elements.button.getAttribute('aria-expanded') === 'true'
    if (isPanelHidden == null && isButtonExpanded) {
      this.hidePanel()
    } else {
      this.elements.panel.removeAttribute('hidden')
      this.elements.button.setAttribute('aria-expanded', 'true')
      // this.querySelector('.disclosure svg').classList.add('rotate')
      this.focus()
      // Scroll to selected country when panel is opened
      this.scrollToSelectedCountry()
    }
  }

  // Used to select an element that is added to the DOM after DOMContentLoaded
  // Don't forget to `await` this function
  async checkForElement(selector, interval = 50, timeout = 4000) {
    try {
      // console.log('checkForElement...');
      const foundElement = await new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          const element = this.querySelector(selector)
          if (element) {
            clearInterval(checkInterval)
            resolve(element)
            return
          }
        }, interval)
        // if element not found after 6 seconds, reject
        setTimeout(() => {
          if (this.querySelector(selector)) return
          clearInterval(checkInterval)
          reject(`"${selector}" not found after ${timeout / 1000}s`)
        }, 6000)
      })
      return foundElement
    } catch (error) {
      console.log(error)
    }
  }
}

customElements.define('localization-form', LocalizationForm)
